import StudentRegForm from './StudentRegForm';

const StudentRegistrationPage = () => {
  return <StudentRegForm />;
};

export default StudentRegistrationPage;
